import classNames from "classnames"
import { FC } from "react"
import { LeftIcon, RightIcon } from "../../libs/corporate/icons/outlined/directions/ChevronCollection"
import { MultiplyIcon as CloseSvg } from "../../libs/corporate/icons/outlined/suggested/SymbolCollection"
import styles from "./styles/TabsPanel.module.scss"


interface ITabPanelProps {
    id: string
    activeId?: string,
    disableId?: string,
    tabs: ITab[],
    onActive?: (tab: ITab) => void,
    onClose?: (tab: ITab) => void
    switchControl?: boolean
    disabledTabIds?: string[]
}

const TabsPanel: FC<ITabPanelProps> = (props) => {

    const isTabDisabled = (tabId: string): boolean => {
        return props.disabledTabIds?.includes(tabId) || false
    }

    function getTabStyle(currentId: string) {
        return classNames(styles.header,
            (currentId === props.activeId
                ? styles.headerActive
                : null),
            (currentId === props.disableId
                ? styles.headerDisabled
                : null),
            (isTabDisabled(currentId)
            ? styles.headerDisabled
            : null)
        )
    }

    function left() {
        const element = document.getElementById(props.id)
        if (element) {
            const val = (parseInt(element.style.left, 10) || 0) - 50;
            element.style.left = val + 'px';
        }
    }

    function right() {
        const element = document.getElementById(props.id)
        if (element) {
            var val = (parseInt(element.style.left, 10) || 0) + 50;
            element.style.left = val + 'px';
        }
    }

    const handleTabClick = (tab: ITab) => {
        if (!isTabDisabled(tab.id)) {
            props.onActive?.(tab)
        }
    }

    return (
        <>
            <div className={styles.wrapper}>
                <div id={props.id} className={styles.panel}>
                    {
                        props.tabs?.map(t => {
                            const isDisabled = isTabDisabled(t.id)
                            return (
                                <div 
                                    key={t.id} 
                                    className={getTabStyle(t.id)} 
                                    onClick={() => handleTabClick(t)}
                                    style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                                >
                                    <div className={styles.content}>
                                        {t.title}
                                        {
                                            props.onClose && !isDisabled &&
                                            <div className={styles.closeIcon} onClick={(e) => {
                                                props.onClose?.(t)
                                                e.stopPropagation()
                                            }}>
                                                <CloseSvg />
                                            </div>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {!props.switchControl &&
                    <ul className={styles.switch}>
                        <li className={styles.switchItem} onClick={() => { }} > <LeftIcon /> </li>
                        <li className={styles.switchItem} onClick={() => { }} > <RightIcon /> </li>
                    </ul>
                }
            </div>
        </>
    )
}

export default TabsPanel